import React,{ PureComponent } from 'react'
import PropTypes from 'prop-types';
import tagsConfigHelper from '../../../helpers/tagsConfigHelper'
import ControlManager from '../ControlManager'
import {
    START_VALIDATE_TAGS,
    ADD_TAG_ERROR
}
from '../../../redux/actions/actionTypes'
import $ from 'jquery'

class DatePickerStartEnd extends PureComponent {
    constructor(props){
        super(props)
        
        this.state ={}

        this.inputRef = React.createRef();

        this.initState=this.initState.bind(this)
        this.initControl = this.initControl.bind(this)
        const validate= this.validate.bind(this)

        this.initState()
        
        // window.emitter.addListener(START_VALIDATE_TAGS, function (message) {
        //     validate()
        // })
    }

    initState(){
        let {doctype}=this.props    

        this.state={
            visible: true,
            disabled: (!doctype || doctype=="")?this.props.disabled:false,
            required:false,
            description:null,
            error:false,
            error_message:null
        }
    }

    initControl() {
        let { doctype, tagid } = this.props

        if (!doctype || !tagid) return

        var tagInfo = tagsConfigHelper.findTagConfig(tagid, doctype)

        if (tagInfo) {
            this.setState({
                visible: tagInfo.visibled,
                disabled: !tagInfo.enabled,
                required: tagInfo.required,
                description: tagInfo.tagDescription,
            })

            ControlManager.setLabel(tagInfo.tagLabel, tagInfo.visibled, tagInfo.required)
            ControlManager.setSubLabel(tagInfo.tagSubLabel, tagInfo.visibled)
        }
        
        if(doctype==="" || doctype==="*"){
            this.setState({disabled:this.props.disabled})
        }
    }

    async validate() {
        let {required,description}=this.state
        let {tagid,validate_required}=this.props
        let control=this.inputRef.current

        if(!control || !tagid || !required || validate_required===false) return

        //console.log("validate : ",tagid)

        this.setState({
            error: false,
            error_message: null
        })
        
        if(!control.value || control.value.length===0){
            let message="กรุณาระบุ " + (description!==null ? description :tagid)

            //console.log(control)

            this.setState({
                error:true,
                error_message: message
            })

         window.emitter.emit(ADD_TAG_ERROR, {
            tagId:tagid,
            description:description,
            error_message:this.state.error_message
        })
        }  
    }

    componentWillReceiveProps(nextProps) {        
        if (this.props.doctype !== nextProps.doctype) {
               this.initControl()
        }

        //กรณีไม่ได้กำหนด DocType บางค่าให้เชื่อตามที่กำหนดจากข้างนอก
        if(!nextProps.doctype || nextProps.doctype==="" || nextProps.doctype==="*"){
            if (this.state.disabled !== nextProps.disabled) {
                this.setState({disabled:nextProps.disabled})
            }
        }
    }

    componentDidMount(){
        this.initControl()
    }

    render() {

        let { disabled, visible } = this.state
        let showsdayall  = false

        if(this.props.showsdayall && this.props.showsdayall  === "All"){
            showsdayall = true
        }

        if (this.props.doctype) {
            var tagInfo =  tagsConfigHelper.findTagConfig(this.props.tagid, this.props.doctype)
            if (tagInfo) {
                disabled = !tagInfo.enabled
                visible = tagInfo.visibled
            }
        }

        let startdate = ''
        let enddate = ''
        if (this.props.setStartdate && this.props.setStartdate !== "") {
           
            startdate = this.props.setStartdate
        }
        else if (this.props.setEnddate && this.props.setEnddate !== "") {
            
            enddate = this.props.setEnddate
        }

        window.$('.js-datepickerstartend')
        .datepicker({
            startDate: startdate == '' ? '' : new Date(startdate),
            endDate: enddate == '' ? '' : new Date(enddate),
            todayHighlight: true
        }).on('changeDate', function (ev) {
            setTimeout(function () {
                $('.datepicker').hide();
                $('.js-datepickerstartend').blur()
            }, 4)
        });
        
        window.$('.js-datepicker-all')
        .datepicker({
            todayHighlight: true
        }).on('changeDate', function (ev) {
            setTimeout(function () {
                $('.datepicker').hide();
                $('.js-datepicker-all').blur()
            }, 4)
        });

        return (
            <input
                ref={this.inputRef}
                {...this.props}
                className={showsdayall ? ["form-control js-datepicker-all",this.props.className].join(' ') : ["form-control js-datepickerstartend",this.props.className].join(' ')   }
                disabled={disabled||this.props.viewMode?"disabled":null}
                style={{visibility: visible?"visible":"hidden"}}
                data-date-format="dd/mm/yyyy"
                autoComplete="off"
            />
        )
    }
}

DatePickerStartEnd.defaultProps = {
    type:"text",
    placeholder: "dd/mm/yyyy",
  };
  
  DatePickerStartEnd.propTypes = {
    doctype: PropTypes.string,
    tagid: PropTypes.string
  };

export default DatePickerStartEnd;